import { configureStore } from "@reduxjs/toolkit";
import slideReducer from "./slide-slice";

const store = configureStore({
    reducer: {
        slide: slideReducer
    }
})

export default store;